import styled from '@emotion/styled';
import media from '@shared/mediaQuery';
import { getStaticImageUrl } from '@utils/createImageUrl';

const AdsProductsStyle = styled('div')`
  .adsproducts {
    &--header {
      ${media.mobile} {
        margin-left: 20px;
      }
      ${media.desktop} {
        display: flex;
      }
      &-title {
        font-size: 24px;
        color: #333333;
        &:after {
          content: '.';
          color: #ff5500;
          font-size: 24px;
          font-family: 'Pretendard-Bold';
        }
        ${media.mobile} {
          line-height: 32px;
        }
        ${media.desktop} {
          font-size: 28px;
          width: 286px;
          flex: none;
          margin-right: 32px;
        }
        span {
          font-family: 'Pretendard-Bold';
        }
      }
      &-desc {
        color: #555555;
        ${media.mobile} {
          font-size: 14px;
          line-height: 22px;
          margin-top: 8px;
          width: calc(100% - 20px);
        }
        ${media.desktop} {
          font-size: 16px;
          line-height: 24px;
          width: 622px;
        }
      }
    }

    &--body {
      ${media.mobile} {
        margin-top: 32px;
      }
      ${media.desktop} {
        margin-top: 59px;
      }
    }
    &--contents {
      ${media.mobile} {
        background-color: #f6f6f6;
        position: relative;
        padding-top: 11px;
        overflow: hidden;
      }
    }
    &--dots {
      display: flex;
      justify-content: space-between;
      width: 35px;
      margin: 0 auto;
    }
    &--dot {
      width: 8px;
      height: 8px;
      border-radius: 100%;
      background-color: #cfcfcf;
      &.active {
        background-color: #333333;
      }
    }
    &--prevbutton {
      z-index: 1;
      position: absolute;
      top: 171px;
      left: 15px;
      transform: rotate(90deg);
      &.disabled {
        display: none;
      }
    }
    &--nextbutton {
      z-index: 1;
      position: absolute;
      top: 171px;
      right: 15px;
      transform: rotate(-90deg);
      &.disabled {
        display: none;
      }
    }

    &--products {
      ${media.mobile} {
        height: 307px;
      }
      ${media.desktop} {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
      }
    }
    &--product {
      ${media.mobile} {
        width: 100vw;
      }
      ${media.desktop} {
        width: 442px;
      }
      &-header {
        display: flex;
      }
      &-beta {
        width: 38px;
        height: 12px;
        background-image: url(${getStaticImageUrl({ fileName: 'beta.png' })});
        background-size: 55%;
        background-repeat: no-repeat;
        margin-top: 15px;
        margin-left: 4px;
        ${media.desktop} {
          width: 41px;
          margin-top: 14px;
        }
      }

      &:nth-of-type(1) {
        .adsproducts--product-image {
          ${media.desktop} {
            background-image: url(${getStaticImageUrl({ fileName: 'ads-search_desktop.jpg' })});
          }
        }
      }
      &:nth-of-type(2) {
        .adsproducts--product-image {
          ${media.desktop} {
            background-image: url(${getStaticImageUrl({ fileName: 'ads-location_desktop.jpg' })});
          }
        }
      }
      &-image {
        ${media.mobile} {
          height: 307px;
          display: block;
          background-repeat: no-repeat;
          background-position: center bottom;
        }
        ${media.desktop} {
          height: 297px;
          display: block;
          background-size: cover;
          background-repeat: no-repeat;
        }
        &-wrap {
          ${media.desktop} {
            background-color: #f6f6f6;
            width: 442px;
            padding-top: 1px;
          }
        }
      }
      &-description-wrap {
        ${media.mobile} {
          width: calc(100% - 40px);
          margin-left: 20px;
        }
      }
      &-title {
        font-family: 'Pretendard-Bold';
        font-size: 18px;
        color: #333333;
        margin-top: 10px;
        ${media.desktop} {
          color: #3a3a3a;
          margin-top: 11px;
          font-size: 20px;
        }
      }
      &-desc {
        font-size: 13px;
        color: #757575;
        line-height: 20px;
        margin-top: 1px;
        ${media.desktop} {
          font-size: 15px;
          line-height: 24px;
          color: #6b6b6b;
          margin-top: 9px;
        }
      }
    }
  }
  .slick-slide {
    ${media.mobile} {
      width: 100vw;
    }
  }
  .adsproducts--product-image {
    &.index-0 {
      ${media.mobile} {
        background-image: url(${getStaticImageUrl({ fileName: 'ads-search_mobile.png' })});
        background-size: 226px 291px;
        background-position: calc(50% - 30px) bottom;
      }
    }
    &.index-1 {
      ${media.mobile} {
        background-image: url(${getStaticImageUrl({ fileName: 'ads-location_mobile.png' })});
        background-size: 302px 268px;
      }
    }
  }

  .slick-dots {
    ${media.mobile} {
      bottom: unset;
      top: -1px;
      margin-left: -15px;
      li {
        width: 4px;
        button:before {
          font-size: 40px;
        }
      }
    }
  }
`;

export default AdsProductsStyle;
